import React from 'react';
import { NavLink } from 'react-router-dom';
import { useState } from 'react';
import crossMark from '../../images/crossMark.png';
import top from '../../images/top.png';

export const isOpen : boolean = false;
export const close : boolean = false;

// Определение типов пропсов для Modal
interface ModalProps {
    isOpen: boolean;   // Типизация пропса isOpen как boolean
    close: () => void; // Типизация функции close, которая не принимает аргументов и не возвращает значение
}

const Modal: React.FC<ModalProps> = ({ isOpen, close }) => {
    const [projectMenuStateValue,setprojectMenuStateValue] = useState(true);
    if (!isOpen) return null;
  
    return (
        <div style={{
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        backgroundColor: 'rgba(0, 0, 0, 0.7)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        zIndex: 1000
        }}>
        <div style={{
            padding: 20,
            width: '50%',
            height: '50%',
            background: '#fff',
            borderRadius: '5px',
            display: 'flex',
            alignItems: 'center',
            flexDirection: 'column',
            position: 'relative'
        }}>
            <div className='flex top:0 justify-end w-full'>
                <img src={crossMark} alt="cross mark" className={isOpen === true ? 'w-8 h-8':'sm:invisible sm:hidden md:visible md:hidden'} onClick={close}/>
            </div>
            <div style={{
            display: 'flex',
            width: '100%',
            height: '100%',
            flexDirection: 'column',
            alignItems: 'start',
            justifyContent: 'center',
            position: 'relative'
        }}>
                <ul className='sm:left-0 sm:top-[5rem] sm:grid sm:items-start sm:justify-center sm:gap-[24px] sm:text-center sm:w-[100%] sm:overflow-auto sm:transition-top delay-[0.4s] 
                justify-between text-base not-italic font-medium uppercase list-none  sm:not-italic sm:font-medium sm:uppercase laptop:text-white desktop:text-white'>
                    <NavLink to='/' className='text-start' onClick={close}>Главная</NavLink>
                    <div className={projectMenuStateValue === false ? 'hidden invisible' : 'flex items-center gap-2'}>
                    <p className='' onClick={()=>{setprojectMenuStateValue(!projectMenuStateValue)}}>Проекты</p>
                        <img src={top} alt="arrow top" className={projectMenuStateValue === false ? 'rotate-180 w-4 h-4' : 'w-4 h-4'} onClick={()=>{setprojectMenuStateValue(!projectMenuStateValue)}}/>
                    </div>
                    <li className={projectMenuStateValue === false ? 'text-start': 'hidden  gap-0 invisible'}><NavLink to='/projectStrij' onClick={close} >ПК СТРИЖ</NavLink></li>
                    <li><NavLink to='/contacts'  className='text-start' onClick={close}>Связаться</NavLink></li>
                </ul>
            </div>
        </div>
        </div>
    );
    };
export default Modal;